<rt-assistant-list-card>
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="nav-requisitions-outline"
      color="colorIconPrimaryDefault"
      background="colorBgPrimarySubduedDefault"
    />
    <div class="text">
      <span class="title">{{ data().title }}</span>
      <span class="meta">
        {{
          'tlc.tellent_assistant.list_item_requisition.hires_count'
            | translate: { hires: data().hiresCount, openings: data().openingsCount }
        }}
        &bull;
        <span class="status">{{ statusLabel() }}</span>
      </span>
    </div>
  </div>
</rt-assistant-list-card>
